/**
 * How a Partner Brand departs from the cap on mileage payouts carried by its Brand.
 *
 * Three states rather than one nullable amount: an empty amount would have to mean both "not configured"
 * and "no cap", and those must not share a representation. A cap left too high is a silent overpayment
 * nobody reports, one left too low is a complaint that arrives on its own - so the unconfigured state is
 * the capped one, and "no cap" has to be chosen out loud.
 */
export enum CreditValueCapMode {
	/**
	 * Take the Brand's amount. The default, and what every partner sits on until somebody says otherwise.
	 */
	INHERIT = "INHERIT",
	/**
	 * Use the partner's own amount instead, for a partner on negotiated terms.
	 */
	FIXED = "FIXED",
	/**
	 * Pay the claim in full, with no cap at all. What the taxi sign-up journey sets on its own.
	 */
	NONE = "NONE"
}

export default CreditValueCapMode;
